var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCp3CalendarHouseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.g,.h{fill:none;}.b{fill:#3c3c46;opacity:0.15;}.b,.c,.d,.e,.f,.g{fill-rule:evenodd;}.c{fill:#ffefe0;}.c,.d,.g,.h{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.d,.f{fill:#fff;}.e{fill:#89d9fb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-calendar-house-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "113.56 43.57 35.71 43.57 51.48 102.43 129.33 102.43 113.56 43.57"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "28.05 37.57 105.95 37.57 123.33 102.43 45.43 102.43 28.05 37.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "28.1 89.44 105.95 89.44 123.33 102.43 45.48 102.43 28.1 89.44"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "105.95 89.44 28.1 89.44 10.72 102.43 88.57 102.43 105.95 89.44"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "105.95 37.57 28.1 37.57 28.1 102.43 123.33 102.43 105.95 89.44 105.95 37.57"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "28.05 37.57 75.2 37.57 57.82 102.43 10.67 102.43 28.05 37.57"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "105.95 37.57 75.2 37.57 57.82 102.43 88.57 102.43 105.95 37.57"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "28.05 37.57 105.95 37.57 88.57 102.43 10.67 102.43 28.05 37.57"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 75.71,
    y1: 59.85,
    x2: 82,
    y2: 59.85
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 73.9,
    y1: 66.62,
    x2: 80.18,
    y2: 66.62
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 72.09,
    y1: 73.38,
    x2: 78.37,
    y2: 73.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 70.28,
    y1: 80.15,
    x2: 76.56,
    y2: 80.15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 77.53,
    y1: 53.08,
    x2: 83.81,
    y2: 53.08
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 68.39,
    y1: 86.92,
    x2: 74.67,
    y2: 86.92
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 87.28,
    y1: 59.85,
    x2: 93.56,
    y2: 59.85
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 85.47,
    y1: 66.62,
    x2: 91.75,
    y2: 66.62
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 83.66,
    y1: 73.38,
    x2: 89.94,
    y2: 73.38
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 81.84,
    y1: 80.15,
    x2: 88.13,
    y2: 80.15
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 89.09,
    y1: 53.08,
    x2: 95.38,
    y2: 53.08
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 79.96,
    y1: 86.92,
    x2: 86.24,
    y2: 86.92
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 75.2,
    y1: 37.57,
    x2: 57.82,
    y2: 102.43
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCp3CalendarHouseIcon);
export default __webpack_public_path__ + "static/media/CP3-calendar-house-icon.f8a08bd670dd5af11c8396a6e60839b1.svg";
export { ForwardRef as ReactComponent };